/**
 * Widget-side style list. Rails passes `styles` from CitationGenerator::Styles
 * so adding a format does not require editing this file. Fallback list matches
 * the V1 registry for isolated widget tests.
 */
export type CitationStyleId = string;

export type CitationStyle = {
  id: CitationStyleId;
  name: string;
};

export const CITATION_STYLES: CitationStyle[] = [
  { id: 'apa', name: 'APA' },
  { id: 'mla', name: 'MLA' },
  { id: 'chicago', name: 'Chicago' },
  { id: 'ieee', name: 'IEEE' },
  { id: 'ama', name: 'AMA' },
  { id: 'acs', name: 'ACS' },
  { id: 'cse', name: 'CSE' },
];

export const DEFAULT_HUB_STYLE: CitationStyleId = 'apa';

/** IEEE / AMA / ACS: citation order, not author-year. */
export const NUMERIC_STYLE_IDS: ReadonlySet<CitationStyleId> = new Set([
  'ieee',
  'ama',
  'acs',
]);
